import { writable, get } from "svelte/store";

import { currentHash, lastHash, isNewDataChanged, isSublistClosed } from "../stores/variables";
import { updateLinkState } from "../svelte/main/menu/Menu.svelte";

import { request } from "./request"
import { contentShellData, entityData, menuData } from "../stores/data"
import { getData } from "./get_data";
import { customAlert } from "./custom_alert";

export function getHashByType(hash, type) {
	let hashes = hash.split("/");
	hash = 0;
	hashes.forEach((_hash, i) => {
		let temp = _hash.split("=");
		if (temp[0][0] == "#") temp[0] = temp[0].slice(1);
		if (temp[0] == type) {
			hash = temp[1];
		}
	})
	return hash;
}

export function navigateByTypeHash(type, hash) {
	let url = "navigation/" + type + "/" + hash;
	request.fetchLocalData(url).then(result => {
		entityData.set(false);
		contentShellData.set(result);
		getData();
	});
}

async function check(type) {
	// if (get(isNewDataChanged)) {
	// 	const confirm = await customAlert("Сохранить изменения?", [
	// 		"Да",
	// 		"Нет",
	// 	]);
	// 	if (confirm == "Да") {
	// 		// buttonHandlerPopup2.set(1)
	// 		// saveData(array);
	// 		return true;
	// 	}
	// 	if (confirm == "Нет") {
	// 		return false;
	// 	}
	// } else {
	// 	return true
	// }
	return true
}

export async function changeHash(type, hash, opts = {}) {
	if (!check(type)) return
	if (!get(currentHash) && !window.location.hash) {
		currentHash.set(type + "=" + hash + "/")
	} else {
		lastHash.set(get(currentHash));
		let hashes = window.location.hash.split("/");
		if (hashes) {
			let isExist = false;
			hashes.forEach((_hash, i) => {
				let temp = _hash.split("=");
				if (temp[0][0] == "#") temp[0] = temp[0].slice(1);
				if (temp[0] == type) {
					isExist = true;
					temp[1] = hash;
					hashes[i] = temp.join("=");
				}
			})
			if (!isExist) {
				hashes[hashes.length - 1] = type + "=" + hash + "/"
			}
			currentHash.set(hashes.join("/"))
		}
	}

	window.location.hash = get(currentHash);
	if (opts.navigate) {
		let hash = getHashByType(get(currentHash), type);
		navigateByTypeHash(type, hash);
	}
	if (opts.callback) opts.callback.call(null);
}

export function removeHashByType(type) {
	if (window.location.hash) {
		let hashes = window.location.hash.split("/");
		hashes.forEach((_hash, i) => {
			let temp = _hash.split("=");
			if (temp[0][0] == "#") temp[0] = temp[0].slice(1);
			if (temp[0] == type) {
				hashes.splice(i, 1);
			}
		})
		currentHash.set(hashes.join("/"))
		window.location.hash = get(currentHash);
	}
}